import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import { log } from '../../services/utils';

import styles from './auth.module.css';

const SubmitButton = ( {
	buttonText = 'Submit',
	className,
	onSubmit,
	...props
} ) => {
	return (
		<>
			{ log( '- submitButton' ) }
			<Button
				className={ `${ styles.submitButton } ${ className }` }
				color="pink"
				fluid
				size="large"
				{ ...props }
				content={ buttonText }
				onClick={ onSubmit }
			/>
		</>
	);
};

SubmitButton.propTypes = {
	buttonText: PropTypes.string,
	className: PropTypes.string,
	onSubmit: PropTypes.func
};

export default memo( SubmitButton );
